export const devisionFactor = 1000

export const showDays = 'days'
export const showWeeks = 'weeks'
export const showMonths = 'months'

export const preFilterLevel = 5